<div class="dropdown-container" *ngIf="isOpen" appOutsideClick [id]="id" (outsideClick)="close()" >


  <ng-container *ngIf="isMobile; then mobile else desktop"></ng-container>

  <ng-template #desktop>
      <div class="rmx-dropdown-item facebook-bg"
        [class.luxury-facebook-button]="listing.isLuxury"
        [class.commercial-facebook-button]="listing.isCommercial"
        [class.residential-facebook-button]="!listing.isLuxury && !listing.isCommercial">
          <a href="https://facebook.com/sharer.php?u={{cdnUrl + listing.detailUrl}}"
            [class.luxury-facebook-button]="listing.isLuxury"
            [class.commercial-facebook-button]="listing.isCommercial"
            [class.residential-facebook-button]="!listing.isLuxury && !listing.isCommercial"
            class="social-button facebook-bg"
            (click)="$event.preventDefault(); openPopup('https://facebook.com/sharer.php?u=' + cdnUrl + listing.detailUrl.substring(1, listing.detailUrl.length), 'Facebook')"
            target="_blank"
            rel="nofollow">
            <span
            [class.luxury-facebook-button]="listing.isLuxury"
            [class.commercial-facebook-button]="listing.isCommercial"
            [class.residential-facebook-button]="!listing.isLuxury && !listing.isCommercial" 
             class="social-button-icon">
                <img 
                 [class.luxury-facebook-button]="listing.isLuxury"
                [class.commercial-facebook-button]="listing.isCommercial"
                [class.residential-facebook-button]="!listing.isLuxury && !listing.isCommercial"
                [src]="'assets/icons/social-media/facebook_white@2x.svg'"/>
            </span>
            <span
            [class.luxury-facebook-button]="listing.isLuxury"
            [class.commercial-facebook-button]="listing.isCommercial"
            [class.residential-facebook-button]="!listing.isLuxury && !listing.isCommercial">Facebook</span>
          </a>
        </div>
        <div class="rmx-dropdown-item"
            [class.luxury-twitter-button]="listing.isLuxury"
            [class.commercial-twitter-button]="listing.isCommercial"
            [class.residential-twitter-button]="!listing.isLuxury && !listing.isCommercial">
            <a [attr.href]="'https://twitter.com/intent/tweet?=' + cdnUrl + listing.detailUrl"
            [class.luxury-twitter-button]="listing.isLuxury"
            [class.commercial-twitter-button]="listing.isCommercial"
            [class.residential-twitter-button]="!listing.isLuxury && !listing.isCommercial"
            target="_blank"
            (click)="$event.preventDefault(); openPopup('https://twitter.com/intent/tweet?text=' + listing.fullAddress + '&url='  + cdnUrl + listing.detailUrl.substring(1, listing.detailUrl.length), 'Twitter')"
            class="social-button twitter-bg">
            <span
            [class.luxury-twitter-button]="listing.isLuxury"
            [class.commercial-twitter-button]="listing.isCommercial"
            [class.residential-twitter-button]="!listing.isLuxury && !listing.isCommercial" 
            class="social-button-icon">
                <img 
                [class.luxury-twitter-button]="listing.isLuxury"
                [class.commercial-twitter-button]="listing.isCommercial"
                [class.residential-twitter-button]="!listing.isLuxury && !listing.isCommercial"
                [src]="'assets/icons/social-media/Twitter_White@2x.svg'"/>
            </span>
            <span
            [class.luxury-twitter-button]="listing.isLuxury"
            [class.commercial-twitter-button]="listing.isCommercial"
            [class.residential-twitter-button]="!listing.isLuxury && !listing.isCommercial"
            >Twitter</span>
            </a>

        </div>
        <div class="rmx-dropdown-item" 
         [class.luxury-email-button]="listing.isLuxury"
            [class.commercial-email-button]="listing.isCommercial"
            [class.residential-email-button]="!listing.isLuxury && !listing.isCommercial"
        >
          <a
          [class.luxury-email-button]="listing.isLuxury"
            [class.commercial-email-button]="listing.isCommercial"
            [class.residential-email-button]="!listing.isLuxury && !listing.isCommercial"
           class="social-button email-bg" (click)="$event.preventDefault(); toggleModal()" style="margin-bottom:0">
            <span 
            [class.luxury-email-button]="listing.isLuxury"
            [class.commercial-email-button]="listing.isCommercial"
            [class.residential-email-button]="!listing.isLuxury && !listing.isCommercial"
            class="social-button-icon">
                <img 
                [class.luxury-email-button]="listing.isLuxury"
            [class.commercial-email-button]="listing.isCommercial"
            [class.residential-email-button]="!listing.isLuxury && !listing.isCommercial"
                [src]="'assets/icons/social-media/email_white.svg'"/>
            </span>
            <span
            [class.luxury-email-button]="listing.isLuxury"
            [class.commercial-email-button]="listing.isCommercial"
            [class.residential-email-button]="!listing.isLuxury && !listing.isCommercial"
            >Email</span>
          </a>

        </div>

  </ng-template>

  <ng-template #mobile>
      <div class="rmx-dropdown-item facebook-bg"
            [class.luxury-facebook-button]="listing.isLuxury"
            [class.commercial-facebook-button]="listing.isCommercial"
            [class.residential-facebook-button]="!listing.isLuxury && !listing.isCommercial">
          <a [attr.href]="'https://facebook.com/sharer.php?u=' + cdnUrl + listing.detailUrl.substring(1, listing.detailUrl.length)"
            [class.luxury-facebook-button]="listing.isLuxury"
            [class.commercial-facebook-button]="listing.isCommercial"
            [class.residential-facebook-button]="!listing.isLuxury && !listing.isCommercial"
            class="social-button facebook-bg has-flex has-justify-content-center"
            target="_blank"
            rel="nofollow">
              <span 
              [class.luxury-facebook-button]="listing.isLuxury"
            [class.commercial-facebook-button]="listing.isCommercial"
            [class.residential-facebook-button]="!listing.isLuxury && !listing.isCommercial"
              class="social-button-icon">
                  <img 
                  [class.luxury-facebook-button]="listing.isLuxury"
                  [class.commercial-facebook-button]="listing.isCommercial"
                  [class.residential-facebook-button]="!listing.isLuxury && !listing.isCommercial"
                  [src]="'assets/icons/social-media/facebook_white@2x.svg'"/>
              </span>
             <span
             [class.luxury-facebook-button]="listing.isLuxury"
            [class.commercial-facebook-button]="listing.isCommercial"
            [class.residential-facebook-button]="!listing.isLuxury && !listing.isCommercial">Facebook</span>
          </a>

        </div>
        <div class="rmx-dropdown-item"
            [class.luxury-twitter-button]="listing.isLuxury"
            [class.commercial-twitter-button]="listing.isCommercial"
            [class.residential-twitter-button]="!listing.isLuxury && !listing.isCommercial">
            <a 
            [class.luxury-twitter-button]="listing.isLuxury"
            [class.commercial-twitter-button]="listing.isCommercial"
            [class.residential-twitter-button]="!listing.isLuxury && !listing.isCommercial"
            [attr.href]="'https://twitter.com/intent/tweet?text=' + listing.fullAddress + '&url='  + cdnUrl + listing.detailUrl.substring(1, listing.detailUrl.length)"
            target="_blank"
            rel="nofollow"
            class="social-button twitter-bg">
                <span 
                [class.luxury-twitter-button]="listing.isLuxury"
                [class.commercial-twitter-button]="listing.isCommercial"
                [class.residential-twitter-button]="!listing.isLuxury && !listing.isCommercial"
                class="social-button-icon">
                  <img 
                  [class.luxury-twitter-button]="listing.isLuxury"
                  [class.commercial-twitter-button]="listing.isCommercial"
                  [class.residential-twitter-button]="!listing.isLuxury && !listing.isCommercial"
                  [src]="'assets/icons/social-media/Twitter_White@2x.svg'"/></span>
                <span
                [class.luxury-twitter-button]="listing.isLuxury"
            [class.commercial-twitter-button]="listing.isCommercial"
            [class.residential-twitter-button]="!listing.isLuxury && !listing.isCommercial">Twitter</span>
            </a>

        </div>
        <div class="rmx-dropdown-item"
        [class.luxury-email-button]="listing.isLuxury"
            [class.commercial-email-button]="listing.isCommercial"
            [class.residential-email-button]="!listing.isLuxury && !listing.isCommercial">
          <a [class.luxury-email-button]="listing.isLuxury"
            [class.commercial-email-button]="listing.isCommercial"
            [class.residential-email-button]="!listing.isLuxury && !listing.isCommercial"
          class="social-button email-bg" style="margin-bottom: 0" (click)="$event.preventDefault(); toggleModal()">
              <span class="social-button-icon"
              [class.luxury-email-button]="listing.isLuxury"
            [class.commercial-email-button]="listing.isCommercial"
            [class.residential-email-button]="!listing.isLuxury && !listing.isCommercial">
                <img
                [class.luxury-email-button]="listing.isLuxury"
            [class.commercial-email-button]="listing.isCommercial"
            [class.residential-email-button]="!listing.isLuxury && !listing.isCommercial"
                 [src]="'assets/icons/social-media/email_white.svg'"/>
              </span>
              <span
              [class.luxury-email-button]="listing.isLuxury"
            [class.commercial-email-button]="listing.isCommercial"
            [class.residential-email-button]="!listing.isLuxury && !listing.isCommercial">Email</span>
          </a>

        </div>
  </ng-template>

</div>
